module.exports = __webpack_public_path__ + "media/assets/analytics-67260a20402e9a2bb5a7632dbf9fbb98.png";